import * as SynonymList from 'types/Synonym/SynonymList';

export type Type = {
	[key: string]: SynonymList.Type;
};

export function create(): Type {
	return {};
}
